module.exports = __webpack_public_path__ + "static/media/connect-love-home.8ee0d63d.svg";